import type { HttpInterceptorFn } from '@angular/common/http';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const lang = localStorage.getItem('app-language') || 'en';

  req = req.clone({
    setHeaders: {
      'Accept-Language': lang,
    }
  });

  return next(req);
};
